var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWaitingFallbackIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 72,
    viewBox: "0 0 72 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Waiting",
    clipPath: "url(#clip0_336_1327)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M35.9993 71.9985C55.8811 71.9985 71.9985 55.8811 71.9985 35.9993C71.9985 16.1174 55.8811 0 35.9993 0C16.1174 0 0 16.1174 0 35.9993C0 55.8811 16.1174 71.9985 35.9993 71.9985Z",
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    opacity: 0.5,
    d: "M35.9982 2.93506C17.7366 2.93506 2.93262 17.7391 2.93262 35.9991C2.93262 54.2591 17.7366 69.0646 35.9982 69.0646C54.2597 69.0646 69.0637 54.2606 69.0637 35.9991C69.0637 17.7376 54.2612 2.93506 35.9982 2.93506ZM32.4082 66.1671C15.7482 64.1847 3.84931 49.0706 5.8317 32.4106C7.8141 15.7506 22.9267 3.85024 39.5881 5.83264C56.2496 7.81504 68.147 22.9291 66.1646 39.5876C64.1822 56.246 49.0696 68.1495 32.4082 66.1671Z",
    fill: "#959595"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M66.1649 39.5879C64.1825 56.2509 49.0699 68.1497 32.4085 66.1674C15.747 64.185 3.84961 49.0709 5.83201 32.4109C7.8144 15.7509 22.927 3.85054 39.5885 5.83294C56.2499 7.81534 68.1473 22.9294 66.1649 39.5879Z",
    fill: "#F1F1F1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M66.1649 39.5879C64.1825 56.2509 49.0699 68.1497 32.4085 66.1674C15.747 64.185 3.84961 49.0709 5.83201 32.4109C7.8144 15.7509 22.927 3.85054 39.5885 5.83294C56.2499 7.81534 68.1473 22.9294 66.1649 39.5879Z",
    fill: "url(#paint0_linear_336_1327)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M52.6599 10.5878C51.251 10.2112 49.8168 9.93602 48.3685 9.7644C31.707 7.782 16.5945 19.6809 14.6121 36.3424C13.9431 41.9543 14.8528 47.6416 17.2388 52.7648C19.6248 57.8881 23.3926 62.2443 28.1186 65.3438C13.7586 61.5069 4.02422 47.6015 5.83201 32.4107C7.81441 15.7492 22.927 3.85032 39.5885 5.83272C44.2557 6.38143 48.731 8.00943 52.6599 10.5878Z",
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M33.75 34.4635V13.056C33.75 13.056 34.051 11.9121 34.9843 12.5894L35.2763 34.161L37.474 34.1188C37.474 34.1188 38.5442 28.8219 38.925 28.2288C39.3058 27.6358 41.1076 26.99 41.1076 26.99C41.1076 26.99 41.0925 26.1938 40.8984 25.9604C40.7042 25.7271 40.2391 25.2409 40.3249 25.0287C40.4107 24.8165 40.507 24.6163 40.507 24.6163C40.507 24.6163 40.2391 23.4392 40.346 23.1216C40.346 23.1216 40.8382 21.8993 40.8984 21.815C40.9268 21.7653 40.9658 21.7224 41.0127 21.6893C41.0595 21.6563 41.1131 21.634 41.1695 21.624C41.2259 21.6139 41.2839 21.6164 41.3392 21.6312C41.3946 21.646 41.4461 21.6728 41.4899 21.7096C41.8361 21.9279 42.518 23.239 42.518 23.239C42.518 23.239 43.3459 23.9916 43.4106 24.7653C43.4753 25.539 42.6956 26.8199 42.6956 26.8199L43.8998 27.3242C43.8998 27.3242 46.7598 28.6488 46.978 28.989C47.1963 29.3292 46.8681 29.8921 46.8681 29.8921L44.0564 29.9388L43.0539 31.4199L43.1863 33.7229L45.0318 34.7104C45.0318 34.7104 45.3072 35.2613 45.2335 35.3892C45.1597 35.5172 51.7948 35.5819 51.7948 35.5819V36.4143C51.7948 36.4143 51.7421 36.8237 51.2047 36.8403C50.6674 36.8568 45.7332 36.8403 45.7332 36.8403L45.3539 39.0982L45.3704 40.4965L46.7251 41.925C46.7251 41.925 46.8064 42.5271 46.4391 42.4834C46.0719 42.4398 44.2791 41.5622 44.2581 40.8698V38.4614L43.9645 36.5964L42.7062 35.6767L41.7383 36.2216L41.2867 39.1599L41.4071 41.3349V41.937L40.7388 43.3866C40.7388 43.3866 40.346 43.4573 40.346 42.7228C40.346 41.9882 40.9059 41.1408 40.9059 41.1408C40.7762 40.7815 40.5869 40.4467 40.346 40.1503C40.0073 39.7845 39.2441 36.026 39.2441 36.026L34.0661 36.4008L33.75 34.4635Z",
    fill: "url(#paint1_linear_336_1327)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M43.1307 42.3483C43.0827 42.5875 42.9768 42.8113 42.8222 43.0001C42.6668 43.1946 42.4951 43.3753 42.3089 43.5405C42.1949 43.6585 42.0575 43.7513 41.9055 43.8129C41.8287 43.842 41.7451 43.848 41.6649 43.8304C41.5847 43.8128 41.5114 43.7722 41.4539 43.7136C41.4032 43.6401 41.376 43.553 41.376 43.4637C41.376 43.3744 41.4032 43.2873 41.4539 43.2138C41.56 43.0699 41.6874 42.943 41.8317 42.8375C42.1569 42.5621 42.3766 42.2128 42.6686 41.9118C43.0148 41.5581 43.1819 42.0397 43.1307 42.3483ZM45.5 41.1983C45.6548 41.4355 45.8651 41.6313 46.1126 41.7688C46.3629 41.9124 46.6253 42.0338 46.8968 42.1316C47.0699 42.2119 47.2585 42.2535 47.4493 42.2535C47.5458 42.2531 47.64 42.2243 47.7203 42.1708C47.8006 42.1173 47.8634 42.0414 47.9008 41.9524C47.9229 41.8512 47.9138 41.7455 47.8745 41.6496C47.8353 41.5536 47.7678 41.4718 47.6811 41.4151C47.5057 41.3052 47.3142 41.2234 47.1136 41.1727C46.6455 41.0132 46.2586 40.7302 45.8146 40.53C45.2893 40.2952 45.3148 40.8867 45.5 41.1983ZM44.779 30.2673C44.779 30.2673 47.4734 31.3465 47.9174 31.321C48.3614 31.2954 48.7588 30.9175 48.6158 30.4043C48.4728 29.891 44.6917 27.9673 44.6917 27.9673L44.779 30.2673Z",
    fill: "#F1F1F1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M44.5643 30.2674C44.5643 30.2674 47.2587 31.3467 47.7012 31.3211C48.1438 31.2955 48.5427 30.9177 48.3997 30.4044C48.2567 29.8911 44.4785 27.9614 44.4785 27.9614L44.5643 30.2674Z",
    fill: "url(#paint2_linear_336_1327)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    d: "M40.8652 33.7716C40.8446 32.9783 40.8647 32.1845 40.9255 31.3933C41.0052 30.2855 40.659 28.9428 41.377 28.0953C41.5878 27.847 42.652 27.6558 42.9786 27.6438C43.7523 27.6347 44.6344 27.7537 45.2365 28.3302C45.7046 28.7817 45.3539 29.8836 45.3012 30.5323C45.2018 31.7862 45.3493 32.2197 45.3629 33.1469C45.3719 33.8454 45.3493 34.6808 44.7864 35.1037C44.4763 35.331 43.6981 35.313 43.3143 35.3385C42.7874 35.3762 41.8286 35.5071 41.3454 35.2543C40.8893 35.0149 40.8818 34.2156 40.8652 33.7716Z",
    fill: "#F1F1F1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_10",
    d: "M40.8652 33.7716C40.8446 32.9783 40.8647 32.1845 40.9255 31.3933C41.0052 30.2855 40.659 28.9428 41.377 28.0953C41.5878 27.847 42.652 27.6558 42.9786 27.6438C43.7523 27.6347 44.6344 27.7537 45.2365 28.3302C45.7046 28.7817 45.3539 29.8836 45.3012 30.5323C45.2018 31.7862 45.3493 32.2197 45.3629 33.1469C45.3719 33.8454 45.3493 34.6808 44.7864 35.1037C44.4763 35.331 43.6981 35.313 43.3143 35.3385C42.7874 35.3762 41.8286 35.5071 41.3454 35.2543C40.8893 35.0149 40.8818 34.2156 40.8652 33.7716Z",
    fill: "url(#paint3_linear_336_1327)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_11",
    opacity: 0.31,
    d: "M41.095 29.6682L41.2591 31.5437C41.2967 32.0128 41.4862 32.4569 41.7988 32.8086C42.1114 33.1603 42.5302 33.4006 42.9916 33.493C43.0413 33.5033 43.0916 33.5103 43.1421 33.5141C43.69 33.5562 44.6218 34.0153 44.6218 34.0153L42.4633 34.6867L41.3374 34.348L40.8662 34.4699L40.9174 31.6581L41.095 29.6682Z",
    fill: "url(#paint4_linear_336_1327)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_12",
    d: "M42.4708 28.136C42.4784 28.2666 42.5117 28.3945 42.5688 28.5123C42.6259 28.6301 42.7056 28.7354 42.8035 28.8223C42.9668 28.9361 43.1631 28.9927 43.3619 28.9834C43.4731 28.9906 43.5844 28.972 43.6873 28.9292C43.7901 28.8864 43.8817 28.8205 43.955 28.7366C44.1055 28.5198 44.0589 28.2203 43.9896 27.9614C43.9567 27.7732 43.865 27.6004 43.7277 27.4676C43.5095 27.296 43.0458 27.281 42.7884 27.3698C42.4934 27.4722 42.4392 27.871 42.4708 28.136Z",
    fill: "#F1F1F1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_13",
    d: "M42.4708 28.136C42.4784 28.2666 42.5117 28.3945 42.5688 28.5123C42.6259 28.6301 42.7056 28.7354 42.8035 28.8223C42.9668 28.9361 43.1631 28.9927 43.3619 28.9834C43.4731 28.9906 43.5844 28.972 43.6873 28.9292C43.7901 28.8864 43.8817 28.8205 43.955 28.7366C44.1055 28.5198 44.0589 28.2203 43.9896 27.9614C43.9567 27.7732 43.865 27.6004 43.7277 27.4676C43.5095 27.296 43.0458 27.281 42.7884 27.3698C42.4934 27.4722 42.4392 27.871 42.4708 28.136Z",
    fill: "url(#paint5_linear_336_1327)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_14",
    d: "M41.8836 25.6206C41.8836 25.47 42.0567 24.4164 41.4711 24.6452C41.2679 24.7204 41.3477 24.9462 41.3853 25.1404C41.444 25.446 41.8866 25.6943 41.8836 25.6206Z",
    fill: "url(#paint6_linear_336_1327)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_15",
    d: "M44.5557 25.6673C44.5707 25.5168 44.3495 24.4632 44.9154 24.7326C45.1111 24.8274 45.0118 25.0336 44.9561 25.2353C44.8718 25.5334 44.5467 25.7396 44.5557 25.6673Z",
    fill: "url(#paint7_linear_336_1327)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_16",
    d: "M35.9981 37.9484C37.0747 37.9484 37.9474 37.0756 37.9474 35.9991C37.9474 34.9225 37.0747 34.0498 35.9981 34.0498C34.9216 34.0498 34.0488 34.9225 34.0488 35.9991C34.0488 37.0756 34.9216 37.9484 35.9981 37.9484Z",
    fill: "#F1F1F1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_17",
    d: "M35.9981 37.9484C37.0747 37.9484 37.9474 37.0756 37.9474 35.9991C37.9474 34.9225 37.0747 34.0498 35.9981 34.0498C34.9216 34.0498 34.0488 34.9225 34.0488 35.9991C34.0488 37.0756 34.9216 37.9484 35.9981 37.9484Z",
    fill: "url(#paint8_linear_336_1327)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_18",
    d: "M35.9371 12.2241C36.1251 12.2241 36.3055 12.2988 36.4384 12.4318C36.5714 12.5647 36.6461 12.7451 36.6461 12.9331V36.5442H35.2236V12.9331C35.2236 12.7451 35.2983 12.5647 35.4313 12.4318C35.5642 12.2988 35.7446 12.2241 35.9326 12.2241H35.9371Z",
    fill: "#959595"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_19",
    d: "M51.8805 35.2783H35.8603C35.5103 35.2783 35.2266 35.5617 35.2266 35.9113C35.2266 36.2608 35.5103 36.5442 35.8603 36.5442H51.8805C52.2305 36.5442 52.5142 36.2608 52.5142 35.9113C52.5142 35.5617 52.2305 35.2783 51.8805 35.2783Z",
    fill: "#959595"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_20",
    d: "M42.7682 28.0578C42.7605 28.2015 42.7857 28.3452 42.8419 28.4777C42.8823 28.5468 42.9331 28.6093 42.9924 28.6629C43.0618 28.7472 43.1562 28.8073 43.2619 28.8345C43.3203 28.8416 43.3797 28.8346 43.4349 28.8142C43.4901 28.7938 43.5397 28.7605 43.5795 28.7171C43.6561 28.6288 43.708 28.5218 43.73 28.407C43.7795 28.1551 43.7876 27.8968 43.7541 27.6423L43.721 27.2163C43.7222 27.0288 43.6734 26.8443 43.5795 26.682C43.5378 26.624 43.4846 26.5752 43.4232 26.5387C43.3619 26.5021 43.2936 26.4787 43.2228 26.4697C42.4807 26.3764 42.7576 27.6423 42.7682 28.0578Z",
    fill: "url(#paint9_linear_336_1327)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_21",
    d: "M44.7158 23.8203C44.7158 23.8203 44.922 26.7676 43.4243 27.1469C41.9266 27.5262 41.7159 25.0395 41.6737 24.1725C41.6316 23.3055 42.3059 22.5785 43.4243 22.717C43.9406 22.7817 44.6059 23.1189 44.7158 23.8203Z",
    fill: "url(#paint10_linear_336_1327)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_22",
    d: "M42.22 22.0366C42.509 21.6076 43.1698 21.561 43.6093 21.8334C43.811 21.9598 43.9811 22.1344 44.2039 22.2233C44.3634 22.285 44.5411 22.294 44.7051 22.3452C44.8692 22.3982 45.0159 22.4943 45.13 22.6236C45.2441 22.7528 45.3212 22.9104 45.3534 23.0798C45.3856 23.2491 45.3716 23.424 45.3129 23.5861C45.2542 23.7482 45.1529 23.8915 45.0197 24.0009C44.8557 24.1334 44.6524 24.2102 44.4763 24.3261C44.4763 24.1485 44.2837 23.9769 44.1362 23.8745C43.984 23.7788 43.8086 23.7268 43.6289 23.724L43.6755 23.8248C43.4183 23.9057 43.1418 23.902 42.8868 23.8143C42.6023 23.7165 42.3013 23.5132 42.0288 23.6427C41.8964 23.7059 41.7624 23.8429 41.6314 23.7767C41.5953 23.751 41.5657 23.7172 41.5451 23.6779C41.5244 23.6387 41.5133 23.5952 41.5125 23.5509C41.4267 22.9774 41.8813 22.5273 42.22 22.0366Z",
    fill: "#4E4E4E"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_23",
    d: "M41.3798 28.0952C41.0741 28.2051 40.8 28.388 40.5812 28.6281C40.3624 28.8681 40.2056 29.158 40.1244 29.4725C39.8565 30.5472 38.8916 34.7935 38.8916 34.7935C38.8916 34.7935 39.8188 34.8989 40.1349 34.8357L41.0546 31.0726C41.0546 31.0726 41.017 28.8388 41.3798 28.0952Z",
    fill: "#F1F1F1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_24",
    d: "M41.3798 28.0952C41.0741 28.2051 40.8 28.388 40.5812 28.6281C40.3624 28.8681 40.2056 29.158 40.1244 29.4725C39.8565 30.5472 38.8916 34.7935 38.8916 34.7935C38.8916 34.7935 39.8188 34.8989 40.1349 34.8357L41.0546 31.0726C41.0546 31.0726 41.017 28.8388 41.3798 28.0952Z",
    fill: "url(#paint11_linear_336_1327)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_25",
    d: "M41.3351 43.0363C41.333 43.1141 41.3517 43.191 41.3893 43.2591C41.4285 43.3125 41.4801 43.3556 41.5396 43.3847C41.5991 43.4138 41.6648 43.4281 41.731 43.4262C41.9685 43.4229 42.1955 43.328 42.3647 43.1613C42.531 42.9953 42.6666 42.8011 42.7651 42.5878C42.8295 42.4734 42.8767 42.3501 42.9051 42.222C42.9638 41.9209 42.8419 41.6048 42.723 41.3188C42.7666 41.4272 42.1449 41.507 42.0877 41.507C41.8439 41.507 41.877 41.6575 41.7957 41.8592C41.6422 42.2446 41.3321 42.5983 41.3351 43.0363Z",
    fill: "#4E4E4E"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_26",
    d: "M41.8301 40.7917L42.1311 41.6527C42.1311 41.6527 42.3208 42.0065 42.6098 41.7446C42.6098 41.7446 42.7061 41.6467 42.7257 41.311L42.4698 40.5464L41.8301 40.7917Z",
    fill: "url(#paint12_linear_336_1327)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_27",
    d: "M47.5032 35.4258C47.3045 37.0545 46.5579 39.3921 46.5248 39.3921C46.3607 39.3455 45.6217 39.5321 45.4546 39.4689C45.3673 39.4343 45.3161 37.7002 45.3643 36.7971C45.3808 36.4961 45.3808 35.5764 45.3808 35.2783L43.3172 35.3385L42.9062 35.3641C42.9091 35.753 42.8774 36.1414 42.8114 36.5247C42.5916 38.1353 42.3674 38.933 42.4456 40.5512C42.4351 40.8146 41.8751 40.923 41.684 40.7197C40.8275 39.8046 40.7703 38.8367 40.5942 37.5949C40.4768 36.767 40.0914 33.74 41.1602 33.5142C41.3176 33.4786 41.4792 33.4655 41.6403 33.475C41.8932 33.4931 42.3824 33.5067 42.5435 33.7219C42.5977 33.749 43.6784 34.2909 44.5906 34.0139L45.5539 33.0205C45.6863 32.8537 45.8707 32.7359 46.0777 32.686C46.2848 32.6361 46.5026 32.6569 46.6964 32.745C47.0727 32.9226 47.3587 33.3471 47.4791 33.8333C47.5996 34.3195 47.5679 34.8945 47.5032 35.4258Z",
    fill: "#F1F1F1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_28",
    d: "M45.3825 40.6188C45.3731 40.6858 45.3782 40.7541 45.3976 40.819C45.4266 40.8814 45.4706 40.9356 45.5255 40.9771C45.9792 41.3756 46.52 41.6623 47.1045 41.814C47.229 41.8558 47.3638 41.8558 47.4883 41.814C47.5827 41.7605 47.654 41.6741 47.6887 41.5714C47.7235 41.4687 47.7191 41.3567 47.6765 41.257C47.5842 41.0603 47.4374 40.8942 47.2535 40.7784C47.0694 40.6634 46.9081 40.5154 46.7779 40.3418C46.7326 40.2375 46.6617 40.1464 46.5717 40.0769C46.4994 40.0467 46.4209 40.0343 46.3429 40.0408C46.1667 40.0408 45.652 39.961 45.509 40.0543C45.366 40.1477 45.3915 40.4322 45.3825 40.6188Z",
    fill: "#4E4E4E"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_29",
    d: "M45.4775 39.4689L45.5618 40.1884C45.6961 40.3095 45.8525 40.4035 46.0224 40.4653C46.0648 40.4783 46.1096 40.4811 46.1532 40.4736C46.1968 40.4661 46.2381 40.4485 46.2737 40.4221C46.3092 40.3958 46.3381 40.3614 46.358 40.3219C46.3779 40.2823 46.3883 40.2387 46.3882 40.1944V40.1357L46.4304 39.3831L45.4775 39.4689Z",
    fill: "url(#paint13_linear_336_1327)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_30",
    d: "M48.4431 30.4058L44.3956 29.5583L44.2119 30.6542C44.2119 30.6542 47.552 32.1022 48.103 31.6777C48.6539 31.2532 48.684 30.6782 48.4431 30.4058Z",
    fill: "#F1F1F1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_31",
    d: "M48.4431 30.4058L44.3956 29.5583L44.2119 30.6542C44.2119 30.6542 47.552 32.1022 48.1029 31.6777C48.6539 31.2532 48.684 30.6782 48.4431 30.4058Z",
    fill: "url(#paint14_linear_336_1327)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_32",
    d: "M44.372 29.6908C44.372 29.6908 43.0323 29.0887 42.519 29.1249C42.0058 29.161 42.0148 29.5268 42.0148 29.5268V29.9271C42.0127 30.006 42.0341 30.0837 42.0761 30.1504C42.1182 30.2171 42.1791 30.2698 42.2511 30.3019C42.3921 30.3675 42.5479 30.3945 42.7027 30.3802C43.0293 30.3305 43.0955 30.1635 43.0955 30.1635C43.0955 30.1635 43.3861 30.4555 43.5652 30.3877C43.7876 30.2957 44.035 30.284 44.2651 30.3546L44.372 29.6908Z",
    fill: "url(#paint15_linear_336_1327)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_33",
    d: "M44.0683 29.5042L43.9072 30.3968L44.2218 30.4404L44.3618 29.5719L44.0683 29.5042Z",
    fill: "#4E4E4E"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_34",
    d: "M44.0667 29.5042L44.0186 29.7826L44.3151 29.8323L44.3602 29.5719L44.0667 29.5042Z",
    fill: "#4E4E4E"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_35",
    d: "M43.9666 29.343L44.5324 29.4535L44.5023 29.607L43.9365 29.4967L43.9666 29.343Z",
    fill: "#F1F1F1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_36",
    d: "M43.9688 29.3433L44.5346 29.4537L44.5046 29.6073L43.9388 29.4969L43.9688 29.3433Z",
    fill: "url(#paint16_linear_336_1327)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_37",
    d: "M41.8821 23.9123C41.8671 24.3083 41.8234 24.7027 41.7512 25.0924C41.756 24.985 41.7448 24.8774 41.7181 24.7733C41.7106 24.7295 41.6907 24.6888 41.6609 24.6559C41.6459 24.6394 41.6255 24.6289 41.6034 24.6261C41.5814 24.6233 41.559 24.6286 41.5405 24.6408C41.56 24.4301 41.4757 24.2224 41.4818 24.0101C41.4857 23.8553 41.5384 23.7058 41.6323 23.5826C41.6363 23.5753 41.6426 23.5694 41.6503 23.5661C41.6596 23.5626 41.6697 23.5626 41.6789 23.5661C41.7468 23.5925 41.8038 23.641 41.8407 23.7039C41.8776 23.7667 41.8922 23.8401 41.8821 23.9123ZM44.6021 25.255L44.703 24.7793C44.703 24.7507 44.718 24.7161 44.7466 24.707C44.7752 24.698 44.7782 24.707 44.7903 24.6935C44.796 24.6865 44.8002 24.6782 44.8023 24.6694L44.9242 24.2826C44.9423 24.2224 44.9604 24.1637 44.9739 24.1019C44.9814 24.0738 44.9814 24.0442 44.9739 24.0161C44.9624 23.9835 44.9394 23.9562 44.9092 23.9394C44.8824 23.9212 44.8521 23.9088 44.8203 23.9029C44.7885 23.8971 44.7558 23.8978 44.7242 23.9052C44.6927 23.9125 44.6631 23.9263 44.6371 23.9457C44.6112 23.965 44.5895 23.9895 44.5735 24.0176C44.5488 24.0576 44.5337 24.1027 44.5295 24.1495C44.5253 24.1963 44.5321 24.2434 44.5494 24.2871C44.6233 24.6042 44.6411 24.9317 44.6021 25.255Z",
    fill: "#4E4E4E"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_38",
    d: "M43.9658 29.346L44.017 29.3159L44.4972 29.4077L44.5318 29.4559L43.9658 29.346Z",
    fill: "#F1F1F1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_39",
    d: "M43.9658 29.346L44.017 29.3159L44.4972 29.4077L44.5318 29.4559L43.9658 29.346Z",
    fill: "url(#paint17_linear_336_1327)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_40",
    d: "M38.6084 34.8976C38.5258 34.9138 38.4484 34.9496 38.3827 35.002C38.3169 35.0544 38.2647 35.1218 38.2305 35.1986C38.1889 35.3511 38.1863 35.5116 38.223 35.6653C38.2322 35.7505 38.2546 35.8337 38.2893 35.9121C38.304 35.9479 38.3287 35.9788 38.3604 36.0009C38.3922 36.0231 38.4297 36.0356 38.4684 36.0371C38.5783 36.0265 38.6415 35.876 38.6475 35.7435C38.6385 35.6112 38.6385 35.4785 38.6475 35.3462C38.634 35.5099 38.634 35.6746 38.6475 35.8384C38.6456 35.9034 38.6682 35.9668 38.7107 36.016C38.7287 36.0289 38.75 36.0364 38.7721 36.0378C38.7942 36.0391 38.8162 36.0342 38.8357 36.0235C38.8831 35.9946 38.9231 35.9551 38.9526 35.9081C38.9821 35.8611 39.0003 35.8078 39.0057 35.7526C39.02 35.6353 39.017 35.5167 38.9967 35.4003C39.0161 35.4842 39.0196 35.571 39.0072 35.6562C38.9941 35.7413 39.0029 35.8284 39.0328 35.9091C39.069 35.9844 39.1578 36.0295 39.215 35.9784C39.2519 35.9367 39.2732 35.8835 39.2752 35.8278C39.2978 35.688 39.3053 35.5462 39.2978 35.4049C39.2746 35.5493 39.2818 35.6969 39.3188 35.8384C39.367 35.9723 39.4949 36.0792 39.6093 36.0295C39.6557 35.9994 39.6937 35.9581 39.72 35.9094C39.7463 35.8608 39.76 35.8064 39.7599 35.7511C39.7719 35.6352 39.7599 35.5177 39.7599 35.4018C39.7598 35.3802 39.7639 35.3587 39.7719 35.3386C39.8035 35.2784 39.8788 35.307 39.9375 35.2995C39.9962 35.292 40.0745 35.1986 40.088 35.1053C40.0983 35.01 40.0912 34.9136 40.0669 34.8208C39.7996 34.8271 39.5321 34.816 39.2661 34.7877C39.0421 34.7853 38.8194 34.8225 38.6084 34.8976Z",
    fill: "url(#paint18_linear_336_1327)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_41",
    d: "M47.5254 35.4258C47.3267 37.0545 46.5801 39.3921 46.547 39.3921C46.3886 39.3828 46.2297 39.3944 46.0743 39.4267C45.8275 39.4629 45.5641 39.5035 45.4723 39.4689C45.4647 39.4689 45.4587 39.4523 45.4512 39.4267C45.3804 39.1648 45.3413 37.7349 45.3774 36.8889V36.7971C45.394 36.4961 45.3925 35.5764 45.3925 35.2783L43.3303 35.3385L42.9194 35.3641C42.9223 35.753 42.8905 36.1414 42.8245 36.5247C42.6048 38.1353 42.3805 38.933 42.4588 40.5512C42.4512 40.7213 42.2164 40.8266 41.9997 40.8251C41.8893 40.8313 41.781 40.7934 41.6986 40.7197C40.8421 39.8046 40.7849 38.8367 40.6088 37.5949C40.4914 36.767 40.1061 33.74 41.1748 33.5142C41.3322 33.4786 41.4939 33.4655 41.655 33.475C41.9078 33.4931 42.3971 33.5067 42.5581 33.7219C42.6123 33.749 43.6931 34.2909 44.6052 34.0139L45.5686 33.0205C45.701 32.8537 45.8854 32.7359 46.0924 32.686C46.2994 32.6361 46.5172 32.6569 46.7111 32.745C47.0874 32.9226 47.3734 33.3471 47.4938 33.8333C47.6142 34.3195 47.5901 34.8945 47.5254 35.4258Z",
    fill: "url(#paint19_linear_336_1327)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_42",
    d: "M42.0085 40.8251C41.8981 40.8313 41.7898 40.7934 41.7074 40.7197C40.8509 39.8045 40.7937 38.8367 40.6176 37.5949C40.5002 36.767 40.1149 33.7399 41.1836 33.5142C40.831 34.2169 40.7194 35.0161 40.866 35.7886C41.1174 37.0289 42.0085 40.8251 42.0085 40.8251Z",
    fill: "url(#paint20_linear_336_1327)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_43",
    d: "M46.0732 39.4267C45.8264 39.4628 45.5629 39.5035 45.4711 39.4689C45.4636 39.4689 45.4576 39.4523 45.45 39.4267C45.3793 39.1648 45.3402 37.7348 45.3763 36.8889V36.7971C45.3928 36.496 45.3913 35.5763 45.3913 35.2783L42.9182 35.3641L42.8174 34.5031C42.8174 34.5031 44.1871 34.8418 44.5966 34.7906C45.006 34.7394 45.4696 34.339 45.4696 34.339C45.4696 34.339 46.0386 33.5488 46.2072 34.339C46.3758 35.0721 46.1063 38.9601 46.0732 39.4267Z",
    fill: "url(#paint21_linear_336_1327)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_44",
    d: "M36.6445 63.6069C36.6445 63.2154 36.3271 62.8979 35.9355 62.8979C35.544 62.8979 35.2266 63.2154 35.2266 63.6069V64.6049C35.2266 64.9964 35.544 65.3139 35.9355 65.3139C36.3271 65.3139 36.6445 64.9964 36.6445 64.6049V63.6069Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_45",
    d: "M36.6445 7.60594C36.6445 7.21439 36.3271 6.89697 35.9355 6.89697C35.544 6.89697 35.2266 7.21439 35.2266 7.60594V8.60391C35.2266 8.99546 35.544 9.31288 35.9355 9.31288C36.3271 9.31288 36.6445 8.99546 36.6445 8.60391V7.60594Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_46",
    d: "M36.6445 63.6069C36.6445 63.2154 36.3271 62.8979 35.9355 62.8979C35.544 62.8979 35.2266 63.2154 35.2266 63.6069V64.6049C35.2266 64.9964 35.544 65.3139 35.9355 65.3139C36.3271 65.3139 36.6445 64.9964 36.6445 64.6049V63.6069Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_47",
    d: "M16.2842 15.4528C16.0073 15.1759 15.5585 15.1759 15.2816 15.4528C15.0047 15.7297 15.0047 16.1785 15.2816 16.4554L15.9873 17.1611C16.2641 17.438 16.713 17.438 16.9899 17.1611C17.2668 16.8842 17.2668 16.4353 16.9899 16.1585L16.2842 15.4528Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_48",
    d: "M55.8848 55.0509C55.6079 54.7741 55.159 54.7741 54.8822 55.0509C54.6053 55.3278 54.6053 55.7767 54.8822 56.0536L55.5878 56.7592C55.8647 57.0361 56.3136 57.0361 56.5905 56.7592C56.8673 56.4824 56.8673 56.0335 56.5905 55.7566L55.8848 55.0509Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_49",
    d: "M7.43553 35.397C7.04398 35.397 6.72656 35.7144 6.72656 36.106C6.72656 36.4975 7.04398 36.8149 7.43553 36.8149H8.4335C8.82505 36.8149 9.14247 36.4975 9.14247 36.106C9.14247 35.7144 8.82505 35.397 8.4335 35.397H7.43553Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_50",
    d: "M63.4365 35.3955C63.045 35.3955 62.7275 35.713 62.7275 36.1045C62.7275 36.4961 63.045 36.8135 63.4365 36.8135H64.4345C64.826 36.8135 65.1434 36.4961 65.1434 36.1045C65.1434 35.713 64.826 35.3955 64.4345 35.3955H63.4365Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_51",
    d: "M15.2838 55.7573C15.007 56.0342 15.007 56.483 15.2838 56.7599C15.5607 57.0368 16.0096 57.0368 16.2865 56.7599L16.9921 56.0542C17.269 55.7774 17.269 55.3285 16.9921 55.0516C16.7153 54.7747 16.2664 54.7747 15.9895 55.0516L15.2838 55.7573Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_52",
    d: "M54.8815 16.1572C54.6046 16.4341 54.6046 16.883 54.8815 17.1598C55.1584 17.4367 55.6073 17.4367 55.8841 17.1598L56.5898 16.4541C56.8667 16.1773 56.8667 15.7284 56.5898 15.4515C56.3129 15.1746 55.864 15.1746 55.5872 15.4515L54.8815 16.1572Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_336_1327",
    x1: 38.7049,
    y1: -36.818,
    x2: 31.5851,
    y2: 154.748,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1F1F1",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#F1F1F1",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#F1F1F1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_336_1327",
    x1: 44.6359,
    y1: -25.4223,
    x2: 41.0308,
    y2: 71.5541,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#959595",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#959595",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#959595"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_336_1327",
    x1: 46.6536,
    y1: 28.988,
    x2: 45.636,
    y2: 30.9087,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_336_1327",
    x1: 43.3685,
    y1: 26.8972,
    x2: 42.7754,
    y2: 39.0189,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopOpacity: 0.19
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopOpacity: 0.24
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_336_1327",
    x1: 43.109,
    y1: 23.5825,
    x2: 42.528,
    y2: 39.2325,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_336_1327",
    x1: 43.4221,
    y1: 26.5494,
    x2: 43.0187,
    y2: 30.6181,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopOpacity: 0.19
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopOpacity: 0.24
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_336_1327",
    x1: 41.3372,
    y1: 25.1238,
    x2: 41.9061,
    y2: 25.1238,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ECC4D7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#EFD4D1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F2EAC9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_336_1327",
    x1: 44.5256,
    y1: 25.1857,
    x2: 45.0313,
    y2: 25.1857,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ECC4D7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#EFD4D1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F2EAC9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_336_1327",
    x1: 35.9213,
    y1: 28.0454,
    x2: 36.0478,
    y2: 41.0145,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#959595",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#959595",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#959595"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_336_1327",
    x1: 43.2408,
    y1: 27.6273,
    x2: 43.3311,
    y2: 28.7502,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ECC4D7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#EFD4D1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F2EAC9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_336_1327",
    x1: 43.182,
    y1: 22.7305,
    x2: 43.2467,
    y2: 28.1975,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ECC4D7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#EFD4D1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F2EAC9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_336_1327",
    x1: 39.6292,
    y1: 31.3179,
    x2: 41.7771,
    y2: 31.8553,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopOpacity: 0.19
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopOpacity: 0.24
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_336_1327",
    x1: 42.3554,
    y1: 38.9373,
    x2: 42.2034,
    y2: 43.027,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ECC4D7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#EFD4D1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F2EAC9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_336_1327",
    x1: 46.0074,
    y1: 37.9997,
    x2: 45.8779,
    y2: 41.4814,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ECC4D7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#EFD4D1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F2EAC9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_336_1327",
    x1: 46.5631,
    y1: 29.9618,
    x2: 46.0829,
    y2: 31.7981,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_336_1327",
    x1: 44.6053,
    y1: 30.043,
    x2: 42.641,
    y2: 29.7601,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ECC4D7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#EFD4D1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F2EAC9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_336_1327",
    x1: 44.2393,
    y1: 29.3189,
    x2: 44.2288,
    y2: 29.629,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_336_1327",
    x1: 44.2639,
    y1: 29.185,
    x2: 44.2398,
    y2: 29.5342,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "white",
    stopOpacity: 0.84
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_336_1327",
    x1: 38.1974,
    y1: 35.4199,
    x2: 40.091,
    y2: 35.4199,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ECC4D7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#EFD4D1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F2EAC9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_336_1327",
    x1: 43.8466,
    y1: 32.1068,
    x2: 44.4683,
    y2: 43.0122,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "white",
    stopOpacity: 0.84
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_336_1327",
    x1: 42.4013,
    y1: 37.1388,
    x2: 39.0115,
    y2: 37.2667,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_336_1327",
    x1: 47.2714,
    y1: 31.9246,
    x2: 42.0437,
    y2: 41.2616,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_336_1327"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 72,
    height: 72,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWaitingFallbackIcon);
export default __webpack_public_path__ + "static/media/waitingFallbackIcon.d16f154b6eddf775ecf87a97e7f31aed.svg";
export { ForwardRef as ReactComponent };